import {
  SIGN_UP,
  SIGN_IN,
  SIGN_OUT,
  CONFIRM_SIGN_UP,
  COMPLETE_SIGN_UP,
  COMPLETE_SIGN_IN,
  COMPLETE_SIGN_OUT,
  COMPLETE_CONFIRM_SIGN_UP,
  RECEIVE_AUTH_ERROR,
  RESEND_CODE,
  COMPLETE_RESEND_CODE,
  SET_AUTH_EMAIL,
  REQUEST_PASSWORD_RESET,
  COMPLETE_REQUEST_PASSWORD_RESET,
  CHANGE_PASSWORD,
  COMPLETE_CHANGE_PASSWORD,
  SUBMIT_FORGOT_PASSWORD,
  COMPLETE_SUBMIT_FORGOT_PASSWORD,
  CLEAR_AUTH_ERROR,
  CHECK_CURRENT_USER,
  COMPLETE_CHECK_CURRENT_USER,
  REDIRECT,
  RECEIVE_USERNAME,
  RECEIVE_CONTEST_AUTH_ERROR,
  CLEAR_CONTEST_AUTH_ERROR
} from '../constants/actionTypes';

const INITIAL_STATE = {
  signedIn: false,
  loading: false,
  user: null,
  authType: '',
  authError: null,
  email: '',
  confirmed: false,
  canResetPassword: false,
  passwordIsReset: false,
  redirect: false,
  userName: ''
};

function checkAuthType(user) {
  const attributes = user.attributes;
  let authType = 'Standard';
  if (attributes && attributes.identities && attributes.identities.length > 0) {
    authType = JSON.parse(attributes.identities)[0].providerName;
  }
  return authType;
}

function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SIGN_UP: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_SIGN_UP: {
      return {
        ...state,
        loading: false,
        email: action.data.user.username
      };
    }
    case SIGN_IN: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_SIGN_IN: {
      return {
        ...state,
        loading: false,
        user: action.user,
        authType: checkAuthType(action.user),
        signedIn: true
      };
    }
    case SIGN_OUT: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_SIGN_OUT: {
      return {
        ...state,
        loading: false,
        user: null,
        authType: '',
        signedIn: false
      };
    }
    case RESEND_CODE: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_RESEND_CODE: {
      return {
        ...state,
        loading: false,
        authError: null
      };
    }
    case CONFIRM_SIGN_UP: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_CONFIRM_SIGN_UP: {
      return {
        ...state,
        loading: false,
        email: null,
        data: action.data,
        confirmed: true,
        authError: null
      };
    }
    case REQUEST_PASSWORD_RESET: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_REQUEST_PASSWORD_RESET: {
      return {
        ...state,
        loading: false,
        canResetPassword: true,
        authError: null
      };
    }
    case CHANGE_PASSWORD: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_CHANGE_PASSWORD: {
      return {
        ...state,
        loading: false,
        passwordIsReset: true,
        authError: null
      };
    }
    case SUBMIT_FORGOT_PASSWORD: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_SUBMIT_FORGOT_PASSWORD: {
      return {
        ...state,
        loading: false,
        canResetPassword: false,
        passwordIsReset: true,
        authError: null
      };
    }
    case RECEIVE_AUTH_ERROR: {
      // console.log(action.error);
      return {
        ...state,
        loading: false,
        authError: action.error
      };
    }
    case SET_AUTH_EMAIL: {
      return {
        ...state,
        email: action.email
      };
    }
    case CHECK_CURRENT_USER: {
      return {
        ...state,
        loading: true
      };
    }
    case COMPLETE_CHECK_CURRENT_USER: {
      return {
        ...state,
        loading: false,
        user: action.user,
        authType: checkAuthType(action.user)
      };
    }
    case CLEAR_AUTH_ERROR: {
      return {
        ...state,
        authError: null,
        email: '',
        confirmed: false,
        canResetPassword: false,
        passwordIsReset: false
      };
    }
    case REDIRECT: {
      return {
        ...state,
        redirect: true
      };
    }
    case RECEIVE_USERNAME: {
      return {
        ...state,
        userName: action.userName
      };
    }

    default:
      return state;
  }
}

export default authReducer;
